import authService from '../services/authService';
import { API_ROOT } from '../config/api';

const API_BASE = `${API_ROOT}/due`;

export async function getMyDues() {
  const res = await fetch(`${API_BASE}`, {
    method: 'GET',
    headers: authService.getAuthHeaders(),
  });
  if (!res.ok) throw new Error(await res.text());
  return await res.json();
}

export async function payDue(id) {
  const res = await fetch(`${API_BASE}/${id}/pay`, {
    method: 'PUT',
    headers: authService.getAuthHeaders(),
  });
  if (!res.ok) throw new Error(await res.text());
  return true;
}


